/* eslint-disable jsx-a11y/control-has-associated-label, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/articles-grid.scss';

const propTypes = {
    items: PropTypes.array.isRequired, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ArticlesGrid = ({ items, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.table}>
                    {items.map(article => (
                        <div className={styles.card}>
                            <a href={`articles/${article.slug}`}>
                                <img
                                    src={article.image.sizes.thumbnail}
                                    className={styles.image}
                                    alt="Sally"
                                />
                            </a>
                            <div className={styles.title}>
                                <a
                                    dangerouslySetInnerHTML={{ __html: article.title }}
                                    href={`articles/${article.slug}`}
                                />
                            </div>
                            <div className={styles.description}>{article.description}</div>
                            <div className={styles.link}>
                                <a href={`articles/${article.slug}`}>Read More</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

ArticlesGrid.propTypes = propTypes;
ArticlesGrid.defaultProps = defaultProps;

export default ArticlesGrid;
